import { callApi } from '../../../../apiCaller';
import { convertFilterOptions, toastError } from '../../../../utils';
import { setIsLoading } from '../../../../actions/general';
import { SellingGroupAPI } from '../../../../services/apis/sellingGroupAPI';

const API_GUEST_SUBSCRIBER_SELLING_GROUP_CATEGORY = 'selling-group-category/guest';
export const API_GUEST_SUBSCRIBER_SELLING_GROUP_CLIENT = 'selling-group/client/selling-group';

export const SET_SUBSCRIBER_SELLING_GROUPS = 'setSubscriberSellingGroups';
export const SET_SUBSCRIBER_SELLING_GROUP_CATEGORIES = 'setSubscriberSellingGroupCategories';
export const SET_FILTER_CATEGORY = 'setFilterCategory';
export const SET_TIMEZONE = 'setTimezone';
export const ATTACHED_EVENT = 'setListEventAttached';

export const SET_SUBSCRIBER_SELLING_GROUP_FILTER_OPTIONS = 'setSubscriberSellingGroupFilterOptions';
export const UPDATE_SUBSCRIBER_SELLING_GROUP_FILTER_OPTION = 'updateSubscriberSellingGroupFilterOption';
export const CLEAR_SUBSCRIBER_SELLING_GROUP_FILTER_OPTIONS = 'clearSubscriberSellingGroupFilterOptions';

export const SET_SUBSCRIBER_SELLING_GROUP_FILTER_SELECTED_SEARCH = 'setSubscriberSellingGroupFilterSelectedSearch';
export const SET_SUBSCRIBER_SELLING_GROUP_FILTER_SELECTED_ITEMS = 'setSubscriberSellingGroupFilterSelectedItems';
export const DELETE_SUBSCRIBER_SELLING_GROUP_FILTER_SELECTED_ITEMS = 'deleteSubscriberSellingGroupFilterSelectedItems';
export const CLEAR_SUBSCRIBER_SELLING_GROUP_FILTER_SELECTED_ITEMS = 'clearSubscriberSellingGroupFilterSelectedItems';

export const setSubscriberSellingGroups = (sellingGroups) => {
     return {
          type: SET_SUBSCRIBER_SELLING_GROUPS,
          payload: sellingGroups,
     };
};

export const setSubscriberSellingGroupCategories = (sellingGroupCategories) => {
     return {
          type: SET_SUBSCRIBER_SELLING_GROUP_CATEGORIES,
          payload: sellingGroupCategories,
     };
};

export const setSubscriberSellingGroupFilterOptions = (payload) => {
     return {
          type: SET_SUBSCRIBER_SELLING_GROUP_FILTER_OPTIONS,
          payload,
     };
};

export const updateSubscriberSellingGroupFilterOption = (payload) => {
     return {
          type: UPDATE_SUBSCRIBER_SELLING_GROUP_FILTER_OPTION,
          payload: {
               category: payload.category,
               body: payload.body,
          },
     };
};

export const clearSubscriberSellingGroupFilterOptions = () => {
     return { type: CLEAR_SUBSCRIBER_SELLING_GROUP_FILTER_OPTIONS };
};

export const setSubscriberSellingGroupFilterSelectedSearch = (payload) => {
     return {
          type: SET_SUBSCRIBER_SELLING_GROUP_FILTER_SELECTED_SEARCH,
          payload,
     };
};

export const setSubscriberSellingGroupFilterSelectedItems = (payload) => {
     return {
          type: SET_SUBSCRIBER_SELLING_GROUP_FILTER_SELECTED_ITEMS,
          payload,
     };
};

export const deleteSubscriberSellingGroupFilterSelectedItems = (payload) => {
     return {
          type: DELETE_SUBSCRIBER_SELLING_GROUP_FILTER_SELECTED_ITEMS,
          payload,
     };
};

export const clearSubscriberSellingGroupFilterSelectedItems = () => {
     return { type: CLEAR_SUBSCRIBER_SELLING_GROUP_FILTER_SELECTED_ITEMS };
};

export const setFilterCategory = (category) => {
     return {
          type: SET_FILTER_CATEGORY,
          payload: category,
     };
};

export const setTimezone = (timezone) => {
     return {
          type: SET_TIMEZONE,
          payload: timezone,
     };
};

export const setListEventOptionsAttached = (events) => {
     return {
          type: ATTACHED_EVENT,
          payload: events,
     };
};

export const fetchSubscriberSellingGroupsRequest = () => async (dispatch) => {
     dispatch(setIsLoading(true));
     return await callApi(API_GUEST_SUBSCRIBER_SELLING_GROUP_CLIENT, 'GET')
          .then((response) => {
               if (response.status !== 200) {
                    toastError(response);
                    return;
               }

               dispatch(setSubscriberSellingGroups(response.data));
               return response.data;
          })
          .finally(() => {
               dispatch(setIsLoading(false));
          });
};

export const fetchSubscriberSellingGroupCategoriesRequest = () => (dispatch) => {
     dispatch(setIsLoading(true));
     callApi(API_GUEST_SUBSCRIBER_SELLING_GROUP_CATEGORY, 'GET')
          .then((response) => {
               if (response.status === 200) {
                    dispatch(setSubscriberSellingGroupCategories(response.data));
               } else {
                    toastError(response);
               }
          })
          .finally(() => dispatch(setIsLoading(false)));
};

export const initialSellingGroupFilterOptions = () => async (dispatch) => {
     const sellingGroupFilterOptions = await SellingGroupAPI.getTrainingProductFilterOptionsForClient();
     if (!sellingGroupFilterOptions) return;

     const newSellingGroupFilterOptions = {};
     Object.entries(sellingGroupFilterOptions).forEach(([key, options]) => {
          newSellingGroupFilterOptions[key] = convertFilterOptions(options);
     });

     dispatch(setSubscriberSellingGroupFilterOptions(newSellingGroupFilterOptions));
     return newSellingGroupFilterOptions;
};

export const clearAllSellingGroupFilterSearchParam = (paramSearch) => (_, getState) => {
     const sellingGroupFilterOptions = getState().subscriber.sellingGroupFilterOptions;

     Object.keys(sellingGroupFilterOptions).forEach((key) => paramSearch.delete(key));

     const newSearchParams = paramSearch.toString().replace(/%2F$/, '');
     return newSearchParams;
};

export const removeSearchParamSellingGroupFilterClosePopup = (sellingGroupFilterOptions, paramSearch) => {
     const handleDeleteSearchParams = (key, options) => {
          options.forEach((option) => {
               const hasSearchParams = paramSearch.has(key, option.value) || paramSearch.has(key, `${option.value}/`);

               if (option.checked && !hasSearchParams) {
                    paramSearch.append(key, option.value);
               }

               if (!option.checked && hasSearchParams) {
                    paramSearch.delete(key, option.value);
                    paramSearch.delete(key, `${option.value}/`);
               }

               if (option.children?.length) {
                    handleDeleteSearchParams(key, option.children);
               }
          });
     };

     Object.entries(sellingGroupFilterOptions).forEach(([key, options]) => {
          handleDeleteSearchParams(key, options);
     });

     const newSearchParams = paramSearch.toString().replace(/%2F$/, '');
     return newSearchParams;
};
